"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANEL_WIDTH = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const GuidesProvider_1 = require("../../providers/GuidesProvider");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
exports.PANEL_WIDTH = 340;
function GuidesHidePanel({ className, selectedToolType, }) {
    const [, setGuidesState] = (0, GuidesProvider_1.useGuidesContext)();
    const onHide = () => {
        setGuidesState(prevState => (Object.assign(Object.assign({}, prevState), { isGuidesExpanded: false })));
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'GuidesHidePanel_Container', children: [(0, jsx_runtime_1.jsx)(Hint, { "data-e2e": 'GuidesHidePanel_Hint', children: selectedToolType === bridge_schema_1.ToolType.None
                    ? (0, i18n_1.Localized)(i18n_1.Strings.guides.gridTitle)
                    : (0, i18n_1.Localized)(i18n_1.Strings.guides.gridHint) }), (0, jsx_runtime_1.jsx)(Button, { onClick: onHide, "data-e2e": 'GuidesHidePanel_Button', children: (0, i18n_1.Localized)(i18n_1.Strings.guides.hint) })] }));
}
exports.default = GuidesHidePanel;
const Container = styled_components_1.default.div.attrs({ role: 'dialog' }) `
  display: flex;
  align-items: center;

  width: ${exports.PANEL_WIDTH}px;
  height: 80px;

  color: ${({ theme }) => theme.text};

  background-color: ${({ theme }) => theme.backgroundSecondary};

  border-radius: 2px;

  box-shadow: ${({ theme }) => theme.tools.guides.shadow};
`;
const Hint = styled_components_1.default.div `
  width: 180px;

  margin: auto 15px;

  font-size: 14px;
`;
const Button = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  width: 120px;
  height: 40px;
  padding: 0px;
  margin: auto 15px auto auto;
`;
